import * as yup from 'yup';

const onboardSkillModalFormValidation = yup.object().shape({
  name: yup.string().trim().label('Skill').required('Skill is a required field'),

});
export default onboardSkillModalFormValidation;
